import { useLocation } from "react-router-dom";

import { useMayaSidebar } from "../context/use-maya-sidebar";

interface MayaPageSeamProps {
  isDesktop: boolean;
}

/**
 * A seam of light on the page card's edge facing the Maya sidebar, shown while
 * the sidebar is open and allowed to see the page — the visible link between
 * "this page" and the chat. Keyed on the path so it flares again whenever the
 * user moves to another page. Rendered inside the page card (which clips it).
 */
export const MayaPageSeam = ({ isDesktop }: MayaPageSeamProps) => {
  const { open, sharePageContext } = useMayaSidebar();
  const { pathname } = useLocation();

  if (!isDesktop || !open || !sharePageContext) return null;
  return <span key={pathname} aria-hidden="true" className="maya-page-seam" />;
};
